import { Component, AfterViewInit, inject, model } from '@angular/core';
import { AuthService } from '../../../authentication/auth.service';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaComponent,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
} from 'ng-recaptcha';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { LoadingService } from '../../../shared/services/loading.service';
import { AlertService } from '../../../shared/services/alert.service';
import { PageFooterComponent } from '../page-footer/page-footer.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-signup-page',
  templateUrl: './signup-page.component.html',
  styleUrls: ['./signup-page.component.scss'],
  standalone: true,
  imports: [
    RecaptchaModule,
    RecaptchaFormsModule,
    FormsModule,
    ReactiveFormsModule,
    PageFooterComponent,
    MatButtonModule,
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: '6LdvnDkUAAAAALe3Hei6WtoK3rsPCsGLlR1k6DfY',
      } as RecaptchaSettings,
    },
  ],
})
export class SignUpPageComponent implements AfterViewInit {
  private readonly formBuilder = inject(FormBuilder);
  private loadingService = inject(LoadingService);
  private alertService = inject(AlertService);
  private captch: string;

  private auth = inject(AuthService);
  formGroup: FormGroup;

  ngAfterViewInit(): void {
    this.loadingService.hide();
  }

  cap = model();

  /**
   * given a captchaRef object, execute catcha verification if sign up form inputs valid; else display informative alerts
   */
  executeCaptchaIfValidInputs(captureRef: RecaptchaComponent): void {
    // grab form input values
    const email = (<HTMLInputElement>document.getElementById('txtEmail')).value;
    const password = (<HTMLInputElement>document.getElementById('txtPassword'))
      .value;
    const reenterPassword = (<HTMLInputElement>(
      document.getElementById('txtReenterPassword')
    )).value;
    const iAgreeCheckbox = <HTMLInputElement>(
      document.getElementById('iAgreeCheckbox')
    );

    if (
      !(
        email &&
        email.indexOf('@') > 0 &&
        email.indexOf('@') != email.length - 1
      )
    ) {
      this.alertService.showAlert({ message: 'Invalid email.' });
    } else if (password != reenterPassword) {
      this.alertService.showAlert({
        message: "Passwords don't match.",
        title: '',
      });
    } else if (!iAgreeCheckbox.checked) {
      this.alertService.showAlert({
        message:
          'Please indicate that you accept the Terms and Privacy Policy.',
      });
    } else if (!this.captch) {
      this.alertService.showAlert({ message: 'Please validate the captcha.' });
    } else {
      this.signUpNewUser(this.captch);
    }
  }

  resolvedCaptcha(captch: string) {
    this.captch = captch;
  }

  /**
   * given sign up form captcha response, sign up new user
   */
  private signUpNewUser(captchaResponse: string): void {
    const displayName = (<HTMLInputElement>(
      document.getElementById('txtDisplayName')
    )).value;
    const email = (<HTMLInputElement>document.getElementById('txtEmail')).value;
    const password = (<HTMLInputElement>document.getElementById('txtPassword'))
      .value;

    this.auth.signUpNewUser(captchaResponse, displayName, email, password);
  }

  onEnterPress(captchaRef: RecaptchaComponent) {
    this.executeCaptchaIfValidInputs(captchaRef);
  }
}
